import "./styles/main.css";

import { initCursor } from "./cursor";
import { initScrollProgress } from "./scroll";
import { splitWords } from "./manifesto";
import { initReveal } from "./reveal";
import { initStatsCountUp } from "./stats";
import { initLang } from "./lang";
import { initNewsletter } from "./newsletter";

function boot(): void {
  const manifestoEl = document.getElementById("manifestoQuote");

  initCursor();
  initScrollProgress();

  if (manifestoEl) splitWords(manifestoEl);

  initReveal(manifestoEl);
  initStatsCountUp();
  initLang(manifestoEl);
  initNewsletter();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot);
} else {
  boot();
}
